import layout from '@/views/layout/layout.vue'
const newSmsList = r => require.ensure([], () => r(require('@/views/system/newSms/list.vue')), 'group-system-newSms')
const newSmslogList = r => require.ensure([], () => r(require('@/views/system/newSms/loglist.vue')), 'group-system-newSms')

const systemNewSms = [
  {
    path: '/system/newSms',
    name: 'system-newSms',
    component: layout,
    redirect: '/system/newSms/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: newSmsList,
        name: 'system-newSms-list',
        meta: {
          displayName: '短信配置',
          requireAuth: true
        }
      },
      {
        path: 'logList',
        component: newSmslogList,
        name: 'system-newSms-logList',
        meta: {
          displayName: '短信日志',
          requireAuth: true
        }
      }
    ]
  }
]

export default systemNewSms



// WEBPACK FOOTER //
// ./src/router/system/newSms.js